import React from "react";
import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__inner container">
        <div className="footer__left">
          <span className="footer__wordmark">
            Airi Iris Ryu<span className="footer__dot">.</span>
          </span>
          <p className="footer__tagline">Pretty knowledge.</p>
        </div>
        <nav className="footer__nav">
          <NavLink to="/" className="footer__link">
            Home
          </NavLink>
          <NavLink to="/portfolio" className="footer__link">
            Portfolio
          </NavLink>
          <NavLink to="/contact" className="footer__link">
            Contact
          </NavLink>
        </nav>
        <p className="footer__copy">
          © {new Date().getFullYear()} — All rights reserved
        </p>
      </div>
    </footer>
  );
}
